import * as React from 'react';
import { CustomTooltip } from '@cian/ui-kit';
import { IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';

import * as styles from './FavoriteTooltip.css';

const ANIMATION_DURATION = 250;

// TODO: Если эксперимент победит, перенести desktop notification UI в @cian/favorites-assign-widget.
type TFavoriteTooltipProps = {
  anchorRef: React.RefObject<HTMLElement | null>;
  isOpen: boolean;
  onAddToFolder(event: React.MouseEvent<HTMLButtonElement>): void;
  onClose(): void;
  onFavoritesLinkClick(event: React.MouseEvent<HTMLAnchorElement>): void;
};

export const FavoriteTooltip: React.FC<TFavoriteTooltipProps> = ({
  anchorRef,
  isOpen,
  onAddToFolder,
  onClose,
  onFavoritesLinkClick,
}) => {
  const [isMounted, setMounted] = React.useState(isOpen);

  React.useEffect(() => {
    if (isOpen) {
      setMounted(true);

      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setMounted(false);
    }, ANIMATION_DURATION);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isOpen]);

  if (!isMounted) {
    return null;
  }

  return (
    <CustomTooltip
      anchorRef={anchorRef}
      arrow={false}
      content={
        <div
          className={clsx(styles['content'], isOpen ? styles['content-visible'] : styles['content-hidden'])}
          data-name="RedesignedFavoriteTooltip"
        >
          <span className={styles['message']}>
            Сохранили в{' '}
            <a className={styles['favorites-link']} href="/favorites/" onClick={onFavoritesLinkClick}>
              избранное
            </a>
          </span>
          <button className={styles['button']} type="button" onClick={onAddToFolder}>
            <IconActionPlus16 color="icon-main-default" display="block" aria-hidden />
            <span>Добавить в подборку</span>
          </button>
        </div>
      }
      flip={false}
      maxWidth={215}
      open={isMounted}
      outside
      placement="bottom-end"
      portal
      preventOverflow={false}
      size="S"
      theme="white"
      withoutPadding
      onClose={onClose}
    />
  );
};
